import React from 'react'
import { Box, HoverHintWrapper, Text } from '@domain-group/suit-theme'

import styles from './styles.module.scss'

interface PermissionIconProps {
  callbacks?: {
    onClick: () => void,
  },
  icon: React.ReactNode,
  label: string,
  value: number | string,
}

const PermissionIcon = (props: PermissionIconProps) => {
  const {
    callbacks, icon, label, value,
  } = props

  const { onClick } = callbacks || {}

  return (
    <Box
      alignItems="center"
      className={styles.root}
      justifyContent="space-evenly"
      onClick={onClick}
      padding="medium"
    >
      <Text fontSize="xsmall">
        <HoverHintWrapper
          childrenHolderProps={{ color: value ? 'bodyFontLightColor' : 'lightGrey' }}
          hintComponent={<HoverHintWrapper.Hint>{label}</HoverHintWrapper.Hint>}
        >
          {icon}
        </HoverHintWrapper>
      </Text>

      <Text color={value ? 'blue' : 'lightGrey'} fontSize="xsmall">
        {value || '--'}
      </Text>
    </Box>
  )
}

export default PermissionIcon
